// extracted by mini-css-extract-plugin
export var centerText = "_6k-8";
export var container = "_6k-0";
export var doughnutContainer = "_6k-7";
export var legend = "_6k-a";
export var legendItemColorDisplay = "_6k-b";
export var legendItemLabel = "_6k-d";
export var legendItemValue = "_6k-c";
export var lg = "_6k-5";
export var maxWidth = "_6k-9";
export var md = "_6k-4";
export var responsive = "_6k-6";
export var sm = "_6k-3";
export var xs = "_6k-2";
export var xxs = "_6k-1";